import React from "react";
import { Card, CardActionArea, CardContent } from "@mui/material";

interface CardContainerProps {
    isSelected: boolean;
    children: React.ReactNode;
    onClick: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

const CardContainer: React.FC<CardContainerProps> = ({
    isSelected,
    onClick,
    onMouseEnter,
    onMouseLeave,
    children,
}) => {
    return (
        <Card
            sx={{
                borderRadius: 0,
                backgroundColor: isSelected ? "rgba(99, 164, 255, 0.3)" : "inherit",
            }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <CardActionArea onClick={onClick}>
                <CardContent sx={{ padding: 0.5 }}>{children}</CardContent>
            </CardActionArea>
        </Card>
    );
};

export default CardContainer;